/**
 * A hook for calling a list of callbacks with the same arguments.
 */
import * as React from "react"

type AnyFunction = (...args: any[]) => any

const useAllCallbacks = (
  ...callbacks: ReadonlyArray<AnyFunction | null | undefined>
) =>
  React.useCallback(
    (...args: any[]) =>
      callbacks
        .filter((x): x is AnyFunction => Boolean(x))
        .forEach(fn => fn(...args)),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    callbacks
  )

export default useAllCallbacks
